import Suru from "../../../../suru/js/app";

$(document).ready(function(){
	var contextPath = $('.header-product').data('context');
	var drawer = $('.drawer');

	Suru.forms();
	if ($("#emailFundDetail").attr("href")) {
		var href = $("#emailFundDetail").attr("href").replace("&","%26") + "&body=" + window.location.href;
		$("#emailFundDetail").attr("href", href);
	}

	if ($(drawer).length > 0) {
		drawerFn();
	}

	function drawerFn() {
		$(drawer).click(function() {
			var drawerClass = 'drawer-expanded';
			var drawerUUID = $(this).data('uuid');
			var drawerToggle = $(this).hasClass(drawerClass);
			var drawerTitle = $(this).find('.drawer-title').text();
			
			if (drawerToggle) {
				$(this).removeClass(drawerClass);
				drawerAction(drawerUUID, 'POST');
				Suru.track.event('Close', 'Fund Risks', drawerTitle);
			} else {
				$(this).addClass(drawerClass);
				drawerAction(drawerUUID, 'DELETE');
				Suru.track.event('Open', 'Fund Risks', drawerTitle);
			}
		});
	}

	function drawerAction(uuid, action) {
		$.ajax({
			type: action,
			url:  contextPath + '/ajax/fund-component/' + uuid
		});
	}
});